module.exports = __webpack_public_path__ + "img/gy.38a57dff.png";